<template>
	<el-dialog class="reportDialog" :visible="show" append-to-body @close="handleClose" @open="generateQRCode(payUrl)">
		<div slot="title">
			<div class="dislogTitle">
				支付二维码
			</div>
		</div>
		<div class="dislogConent">
			<img :src="imgUrl" style="width: 2rem;height: 2rem;" />
		</div>
		<div slot="footer">
			<div class="menuBox">
				<el-button class="myCancel" plain size="medium" @click="handleClose">取消</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import QRCode from 'qrcode';
	export default {
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			payUrl: {
				type: String,
				default: '',
			},
			orderType: {
				type: [String, Number],
				default: '',
			},
			orderId: {
				type: [String, Number],
				default: '',
			},
		},
		data() {
			return {
				timer: null,
				imgUrl: '',
			}
		},
		methods: {
			handleClose() {
				if (this.timer) {
					clearInterval(this.timer);
				}
				this.$emit('close')
			},
			generateQRCode(text) {
				let that = this
				QRCode.toDataURL(text, function(error, url) {
					that.imgUrl = url
					that.timer = setInterval(() => {
						that.checkOrder()
					}, 5000)
				});
			},
			checkOrder() {
				//1会员订单，2积分订单
				this.$api.post('/Notify/check_order', {
					order_id: this.orderId,
					type: this.orderType
				}).then(res => {
					if (res.code == 1) {
						this.handleClose()
						this.$emit('success')
					}
				}).catch(err => {
					console.log(err);
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.reportDialog {

		::v-deep .el-dialog {
			width: 3rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__headerbtn {
				top: .24rem;
				right: .24rem;
				font-size: .16rem;
			}

			&__body {
				padding: 0 .24rem;
				display: flex;
				flex-direction: column;
				align-items: center;

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.myCancel {
						padding: .1rem .2rem;
						border-radius: .04rem;
						font-size: .14rem;
					}
				}
			}
		}
	}
</style>